import React, { useState } from "react";
import { Modal } from "antd";

import Icons from "components/icons";
import { cloneChildren } from "utils";


const ModalStandard = ({
        modalButton,
        extraClass = "modal-light",
        ...props
    }) => {

    const [ showModal, setShowModal ] = useState(false);

    return(
        <>
            { React.cloneElement( modalButton, { onClick : () =>  setShowModal(true)}) }
            <Modal
                className={ `modal-standard ${ extraClass }` }
                visible={ showModal }
                centered
                width={ "auto" }
                closeIcon={ <Icons.Cross /> }
                destroyOnClose={ true }
                footer={ null }
                onOk={() => setShowModal(false)}
                onCancel={() => {
                    setShowModal(false)
                }}
            >
                { cloneChildren(
                    props.children,
                    { action : () =>  setShowModal(false)}
                )}
            </Modal>
        </>
    );
}

export default ModalStandard;

